/**
 * Copyright 2024 AutoZone, Inc.
 * Content is confidential to and proprietary information of AutoZone, Inc., its
 * subsidiaries and affiliates.
 */
import React from 'react';
import { View, Text } from '@az/starc-ui';
import cx from 'classnames';
import styles from './styles.module.scss';
import { whiteInfoIcon } from '@/constants/images/infoIcon';
import Image from '@/components/NextImage';
import { autoZoneRewardsIcon } from '@/constants/images/autoZoneRewardsIcon';
import { RewardsInfoTooltip } from './RewardsInfoTooltip';
import { useDeviceDetector } from '@/hooks/useDeviceDetector';

type RewardsBadgeProps = {
  amount?: number;
  className?: string;
  rewardsHeader?: string;
  rewardsBody?: string;
};

export const RewardsBadge: React.FC<RewardsBadgeProps> = ({
  amount,
  className,
  rewardsHeader,
  rewardsBody,
}) => {
  const { platform } = useDeviceDetector();
  const isWindows = platform === 'windows';

  return (
    <View direction="row" align="center">
      <View
        direction="row"
        align="center"
        justify={'center'}
        className={cx(styles.rewardsBadge, className)}
        attributes={{ 'data-testid': 'rewards-badge-container' }}
      >
        <Image
          src={autoZoneRewardsIcon.src}
          alt={autoZoneRewardsIcon.alt}
          width={27.51}
          height={16}
          data-testid="rewards-badge-icon"
        />
        <Text
          as="span"
          className={cx(styles.rewardText, { [styles.textWindowsFix]: isWindows })}
          attributes={{ 'data-testid': 'rewards-badge-text' }}
        >
          {`$${amount} Bonus Reward`}
        </Text>
        <RewardsInfoTooltip
          classes={{
            icon: styles.infoIcon,
            container: styles.infoToolTipContainer,
            popper: styles.infoToolTipPopper,
            title: styles.infoToolTipTitle,
            body: styles.rewardsPopperBody,
          }}
          iconSrc={whiteInfoIcon}
          header={rewardsHeader ?? ''}
          body={rewardsBody ?? ''}
          data-testid="rewards-badge-info-tooltip"
        />
      </View>
    </View>
  );
};
